import { BiErrorCircle as ErrorIcon } from 'react-icons/bi'

const CardError = () => {
    return (
        <div
            className='flex justify-center flex-col items-center'
        >
            <ErrorIcon className='w-[3em] h-[3em] text-WHMRed mt-8'/>
            <p className='mt-4 text-WHMRed text-center'>
                Something went wrong.<br/> 
                Please try again later.
            </p>
        </div>
    )
}

export default CardError